import axios from "axios";
import { server } from "./constant";

// Create an Axios instance
const api = axios.create({
  baseURL: `${server}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add authentication token
api.interceptors.request.use(
  (config) => {
    // Get user token from persisted Redux store
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      try {
        const parsed = JSON.parse(persistedState);
        const userState = JSON.parse(parsed.user || '{}');
        
        if (userState.token && userState.isLoggedIn) {
          config.headers.Authorization = `Bearer ${userState.token}`;
        }
      } catch (error) {
        console.error('Error parsing persisted state:', error);
      }
    }

    // Get admin token (for admin requests)
    const adminState = localStorage.getItem('adminState');
    if (adminState) {
      try {
        const parsed = JSON.parse(adminState);
        if (parsed.token && parsed.isLoggedIn) {
          config.headers.Authorization = `Bearer ${parsed.token}`;
        }
      } catch (error) {
        console.error('Error parsing admin state:', error);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 errors (unauthorized)
    if (error.response?.status === 401) {
      // Clear invalid tokens
      localStorage.removeItem('adminState');
      
      // For user 401 errors, we might want to dispatch logout action
      // but we can't access store directly here, so we'll let components handle it
      
      // Redirect to login if on admin pages
      if (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/dashboard')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
